export default "__VITE_ASSET__BS0ONaU3__"